import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigitalPublicationContentFormComponent } from './components/digital-publication-content-form/digital-publication-content-form.component';
import { DigitalPublicationContentRoutingModule } from './digital-publication-content-routing.module';
import { SharedModule } from '../shared/shared.module';
import { SharedFormSectionsModule } from '../shared-form-sections/shared-form-sections.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SectionHeaderComponent } from '../shared/standalone/components/section-header/section-header.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [DigitalPublicationContentFormComponent],
  imports: [
    CommonModule,
    DigitalPublicationContentRoutingModule,
    SharedModule,
    SharedFormSectionsModule,
    MatSnackBarModule,
    MatDialogModule,
    SectionHeaderComponent,
  ],
})
export class DigitalPublicationContentModule {}
